import { InventoryStaking } from '@nftx/abi';
import {
  INVENTORY_STAKING,
  Provider,
  Signer,
  config,
  getChainConstant,
  getContract,
} from 'nftx.js';

// TODO: move to nftx.js
const claimIpRewards = ({
  positionId,
  provider,
  signer,
  network = config.network,
}: {
  provider: Provider;
  signer: Signer;
  network?: number;
  positionId: string;
}) => {
  const contract = getContract({
    abi: InventoryStaking,
    address: getChainConstant(INVENTORY_STAKING, network),
    provider,
    signer,
  });

  return contract.write.collectWethFees({ args: [[BigInt(positionId)]] });
};

export default claimIpRewards;
